<div class="rfp-container">
  <div class="rfp-form">
    <div class="rfp-form-title">Open call for <br />light installations</div>

    <div class="rfp-form-description">
      Wire Festival, an annual festival of electronic music welcoming tens of
      thousands of guests, seeks proposals for light-based installations to
      present within its 2026 edition, May 14-17. Prior editions have proudly
      featured work by Lumus Instruments, Collectif Scale, Inner Light NYC, and
      more. For our 5th edition we open this request to proposals we can
      consider programming for the festival in May.
      <br />
      <br />
      Successful installations in the festival context offer a space for
      reflection; they are interstitial spaces that create an alternate dynamic
      for the festival visitors senses, a place to refresh. The installations
      work in dark especially, but present in daylight, and can live with sounds
      coming from rooms around them. Installations tend to be tech-forward,
      light-centric, and use play as a strategy for engagement.
      <br />
      <br />
      Proposals should include:
      <ul>
        <li>A one-paragraph textual description of the proposed idea</li>
        <li>At least two visual representations of the installation</li>
        <li>A short artist bio and links to past work</li>
        <li>A budget inclusive of all costs and fees throughout</li>
        <li>
          Practical timeline necessary for execution on site, both to install
          and strike
        </li>
      </ul>
      <br />
      Proposals should be in the form of a PDF that is not more than 5 pages,
      and should be submitted before December 23rd 2025. Selected proposals
      would be chosen before the end of January 2026.

      <br />
      <br />
      <br />

      <div class="quote">
        “Beyond [Wire Festivals] lineup and the location, the nonstop nature of
        the music created an experience not unlike a fever dream. With so many
        choosing to remain in the same space in search of the most extended
        experience, attendees pushed their bodies and minds to their limits out
        of pure desire and dedication to the music. ” - Static Mag
      </div>
    </div>

    <form [formGroup]="form" class="rfp-form-container">
      <div class="rfp-form-container-title">SUBMISSION FORM</div>

      <label for="full-name-input" class="rfp-form-container-label"
        >Full name
        <span class="rfp-form-container-label-required">*</span></label
      >
      <input
        id="full-name-input"
        [ngClass]="{
          'rfp-form-container-input__error':
            form.get('fullName')?.invalid && form.get('fullName')?.touched
        }"
        class="rfp-form-container-input"
        type="text"
        formControlName="fullName"
      />

      <label for="full-name-input" class="rfp-form-container-label"
        >Email <span class="rfp-form-container-label-required">*</span></label
      >
      <input
        id="email-input"
        [ngClass]="{
          'rfp-form-container-input__error':
            form.get('email')?.invalid && form.get('email')?.touched
        }"
        class="rfp-form-container-input"
        type="text"
        formControlName="email"
      />

      <label for="project-name-input" class="rfp-form-container-label"
        >Project name
        <span class="rfp-form-container-label-required">*</span></label
      >
      <input
        id="project-name-input"
        [ngClass]="{
          'rfp-form-container-input__error':
            form.get('projectName')?.invalid && form.get('projectName')?.touched
        }"
        class="rfp-form-container-input"
        type="text"
        formControlName="projectName"
      />

      <label class="rfp-form-container-label"
        >Upload proposal (PDF)
        <span class="rfp-form-container-label-required">*</span></label
      >

      <div
        class="personal-form-container-profile-picture-upload"
        (click)="fileInput.click()"
        style="cursor: pointer"
      >
        <div class="personal-form-container-profile-picture-upload-text">
          <input
            id="actual-file-input"
            #fileInput
            type="file"
            accept="application/pdf"
            (change)="handleFileSelect($event)"
            hidden
            class="personal-form-container-profile-picture-upload-text-title"
          />
          <label
            for="actual-file-input"
            class="file-input-label"
            (click)="$event.stopPropagation()"
          >
            <img src="assets/imgs/upload.svg" alt="upload" />
            <span class="file-input-text">Upload proposal (PDF)</span>
          </label>
          <div
            class="personal-form-container-profile-picture-upload-text-description"
          >
            PDF (max 5 pages)
          </div>
        </div>
      </div>

      <div class="rfp-form-container-button-container">
        <button
          class="rfp-form-container-button red-button"
          [ngClass]="{ disabled: form.invalid || loading }"
          [disabled]="form.invalid || loading"
          (click)="checkTickets()"
        >
          @if(loading) { Loading... }@else { SUBMIT }
        </button>
      </div>
    </form>
  </div>
</div>
